<div class="row">
  <div class="col">
    <h6 class="font-weight-light page-header pt-1" style="margin-top: 8px; margin-left: 15px;">{{ 'orgprojectlist.title' | trans }}</h6>
    <p class="page-header-sub" style="margin-left: 15px;">{{ 'orgprojectlist.titlesub' | trans }}</p>
  </div>
  <div class="col-auto pt-3 pb-2">
    <div class="row">
     
      <div class="col pl-0">
        <div class="dropleft" *ngIf="canEditOrg() && !isFilterShown">
          <button class="btn-empty border-0" type="button" 
          id="dropdownMenuButton" 
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" 
            matTooltip="{{ 'orgprojectlist.crateanewproject' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
          <span  
          class="material-icons portal-icon align-middle f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
            add
        </span>
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">

                          <a *ngIf="noCustomersYet" class="dropdown-item text-center" >    
      <p class="mb-0 align-middle">{{ 'orgprojectlist.createcustomer' | trans }} bx
         <button routerLink="/customers" class="btn-empty border-0"
      matTooltip="{{ 'orgprojectlist.createcustomer' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"> 
      
      <span  
      class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
      add
      </span>
      </button>
      </p>
     </a>
                <a *ngIf="!noCustomersYet" class="dropdown-item text-center" data-toggle="modal" data-target="#templatelistModal">    
      <p class="mb-0 align-middle">{{ 'orgprojectlist.fromtemplate' | trans }} 
         <button data-toggle="modal" data-target="#templatelistModal" class="btn-empty border-0"
      matTooltip="{{ 'orgprojectlist.fromtemplatetip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"> 
      
      <span  
      class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
      note_add
      </span>
      </button>
      </p>
     </a>

                   <a class="dropdown-item text-center" *ngIf="!noCustomersYet" data-toggle="modal" data-target="#orgProjectAddModal">    
      <p class="mb-0 align-middle">{{ 'orgprojectlist.fromblank' | trans }} 
         <button data-toggle="modal" data-target="#orgProjectAddModal" class="btn-empty border-0"
      matTooltip="{{ 'orgprojectlist.createblank' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"> 
      
      <span  
      class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
      post_add
      </span>
      </button>
      </p>
     </a>
            <!--SHOULD ONLY BE VISIBLE IF YOU DONT HAVE A CUSTOMER-->
            <!-- <a class="dropdown-item pt-2" *ngIf="noCustomersYet" type="button" routerLink="/customers"><p class="mb-0">Create Customer</p>
            </a> -->
              <!-- <a matTooltip="Create a Customer to start creating projects" matTooltipPosition="above" matTooltipShowDelay="500" routerLink="/customers" class="info-link" *ngIf="noCustomersYet" > <span class="material-icons">
                info
                </span></a> -->
                <!-- <a *ngIf="!noCustomersYet" type="button"><p class="mb-0">From Template <button data-toggle="modal" data-target="#taghandlerModal" class="btn-empty border-0"
                  matTooltip="Manage tags" matTooltipPosition="above" matTooltipShowDelay="500"> 
                  
                  <span  
                  class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
                  note_add
                  </span>
                  </button></p></a> -->
            <!-- <a class="dropdown-item" type="button" data-toggle="modal" href="#orgProjectAddModal" *ngIf="!noCustomersYet"><p class="mb-0">From Blank</p></a> -->
          </div>
        </div>
      </div>
         <div class="col- pr-0">


<div class="dropleft" style="width:70px!important;">
  <button class="btn-empty border-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
 <span
          class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
          more_vert
        </span>  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <!-- <a class="dropdown-item text-center" data-toggle="modal" data-target="#taghandlerModal">    
      <p class="mb-0 align-middle">Tag manager
         <button data-toggle="modal" data-target="#taghandlerModal" class="btn-empty border-0"
      matTooltip="Manage tags" matTooltipPosition="above" matTooltipShowDelay="500"> 
      
      <span  
      class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
      label
      </span>
      </button>
      </p>
     </a> -->
    <a (click)="toggleActiveFilter()" class="dropdown-item text-center" >
          <p class="mb-0 align-middle">{{ 'orgprojectlist.togglevisibility' | trans }}   <button  class="btn-empty border-0"
            matTooltip="{{ 'orgprojectlist.togglevisibilitytip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
        
            <span 
            class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
            visibility
            </span>
            </button></p> 
       </a>
  </div>
</div>


    </div>
    </div>
  </div>
</div>
  <div class="loading_overlay rounded" *ngIf="showSpinner">
    <app-loader></app-loader>
    </div>
    <app-tagfilter [label]="true" [listToFilter]="projectlist" (filteredList)="setFilteredList($event)"  class="float-right" [tagtype]="'project'"></app-tagfilter>
  
  <div id="accordion" class="rounded">
<div  *ngFor="let project of filteredProjectList; let i = index" class="container-fluid p-0 card" >
  <div #projects class="row cursor-pointer p-3 ml-0 mr-0" (click)="projectClicked(project)" data-toggle="collapse" 
  [attr.href]="'#projectdata_' + project.projectId" 
  [ngClass]="{'op-1 bg-lightergrey': clickedproject && project.projectId == clickedproject.projectId,
   'op-05 transistion': project.isactive != undefined && project.isactive == false}">
    <div class="col-auto">
      <!-- <app-customerlogo [customerId]="project.customer" [enableChange]="false"></app-customerlogo> -->
    </div>
    <div class="col-5 col-sm-4">
      <a  matTooltip="{{ 'orgprojectlist.showdetailsof' | trans }}" matTooltipPosition="above" matTooltipShowDelay="1000">
        <h6 class=" align-middle mb-0 my-auto lh-35 pl-2 cursor-pointer text-truncate">{{ project.title }}</h6>
      </a>
    </div>
    <div class="col-3 align-middle">
      <app-customername [link]="true" [customerId]="project.customer"></app-customername>
    </div>
    <div class="col col-md-2 d-none d-sm-none d-md-block">
      <p class="mb-0 font-weight-light lh-35 align-middle text-truncate cursor-pointer">{{ 'orgprojectlist.created' | trans }}{{ project.created  | date:'yyyy-MM-dd' }}</p>
    </div>
    <div class="col d-none d-sm-none d-md-none d-lg-block">
     <app-personname [viewtypeportal]="true" [personId]="project.creator"></app-personname>
    </div>
  </div>
<div id="projectdata_{{project.projectId}}">
  <div [ngClass]="{'op-1 bg-lightergrey': clickedproject && project.projectId == clickedproject.projectId, 'op-05 bg-lightergrey': project.isactive != undefined && project.isactive == false,'show bg-lightergrey':showProject == project.projectId}" class="collapse" data-parent="#accordion">
    <div class="row">
      <div class="col">
        <a matTooltip="{{ 'orgprojectlist.title' | trans }}"editprojecttip matTooltipPosition="above" matTooltipShowDelay="1000">
          <h6 class="cursor-default pl-4 font-weight-light">{{ 'orgprojectlist.projectdescription' | trans }}</h6></a>
          <p class="cursor-default pl-4 pb-3">{{ project.projectdescription}}</p>
      </div>
      <div class="col-5 col-sm-5 col-md-4 col-lg-3 col-xl-3">
        <div class="row">
          <!-- <div class="col pl-0 pr-0">
            <a *ngIf="canEdit(project.projectId)" data-toggle="modal" data-target="#assignTags" class="cursor-pointer">
              <span matTooltip="Assign tags to project" matTooltipPosition="above" matTooltipShowDelay="500" [ngClass]="{'animate-highlight': showAssignGuide== project.projectId}" 
              class="material-icons float-right f-24 zoom opacity-reverse pl-1 pr-1">
              label
                </span>
            </a>
          </div> -->
          <div class="col pl-0 pr-0">
            <a *ngIf="canEdit(project.projectId)" data-toggle="modal" (click)="setAssignProject(project)" data-target="#assignPeople" class="cursor-pointer">
              <span matTooltip="{{ 'orgprojectlist.assignpeopletoproject' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" [ngClass]="{'animate-highlight': showAssignGuide== project.projectId}" 
              class="material-icons float-right f-24 zoom opacity-reverse pl-1 pr-1">
                person_search
                </span>
            </a>
          </div>
          <div class="col pl-0 pr-0">
            <a *ngIf="canEdit(project.projectId)" (click)="setDelete(project,i)" data-toggle="modal" href="#deletemodal" class="cursor-pointer">
              <i matTooltip="{{ 'orgprojectlist.deleteprojecttip' | trans }}"  matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons float-right pl-1 pr-1 f-24 zoom opacity-reverse cursor-pointer">
                delete
                </i></a>
          </div>
          <div class="col pl-0 pr-0">            
            <a *ngIf="canEdit(project.projectId)" (click)="projectClicked(project)" data-toggle="modal" href="#orgProjectEditModal" class="cursor-pointer">
            <span class="material-icons float-right f-24 pl-1 pr-1 cursor-pointer opacity-reverse zoom" matTooltip="{{ 'orgprojectlist.editprojecttip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
              create
            </span>
          </a>
        </div>
          <div class="col pl-0">
            <a *ngIf="canEditOrg() && (project.isactive == true || project.isactive == undefined)" (click)="setActiveState(project)" data-toggle="modal" href="#disableProject" class="cursor-pointer">
              <span class="material-icons float-right f-24 pl-1 pr-1 zoom opacity-reverse cursor-pointer" matTooltip="{{ 'orgprojectlist.disableorenableproject' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                visibility_off
              </span>
              </a>
              <a *ngIf="canEditOrg() && project.isactive == false" (click)="setActiveState(project)" data-toggle="modal" href="#disableProject" class="cursor-pointer">
                <span class="material-icons float-right f-24 pl-1 pr-1 zoom opacity-reverse cursor-pointer" matTooltip="{{ 'orgprojectlist.disableorenableproject' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                  visibility
                </span>
                </a>
          </div>
          <div class="col pl-0 pr-3">
            <app-projecttemplatecreate [project]="project"></app-projecttemplatecreate>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="projectdata_{{project.projectId}}" >
<div [ngClass]="{'op-1 bg-lightergrey': clickedproject && project.projectId == clickedproject.projectId, 'op-05 bg-lightergrey': project.isactive != undefined && project.isactive == false,'show bg-lightergrey':showProject == project.projectId}" class="collapse" data-parent="#accordion">
  <app-orgprojectmemberlist [memberToAdd]="memberToAdd" [membersToAdd]="membersToAdd" [projectId]="project.projectId"></app-orgprojectmemberlist>
  <app-orgprojectpendingjoinerlist [pendingJoinerToAdd]="pendingJoinerToAdd" [pendingJoinerToRemove]="pendingJoinerToRemove" (acceptedJoiner)="joinerToAdd($event)" [projectId]="project.projectId"></app-orgprojectpendingjoinerlist>
</div>
</div>
</div>
  </div>
  <div class="spacer"></div>
  <div class="row mobile-nav-toggle " style="margin-top:20px;">
    <div class="col">
      <div class="dropdown">
        <button class="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <p class="btn-text">{{ 'orgprojectlist.createproject' | trans }}</p>
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" data-toggle="modal" data-target="#templatelistModal"><p class="mb-0">{{ 'orgprojectlist.fromtemplate' | trans }}</p></a>
            <a class="dropdown-item" data-toggle="modal" href="#orgProjectAddModal"><p class="mb-0">{{ 'orgprojectlist.fromblank' | trans }}</p></a>
        </div>
      </div>
    </div>
    <div class="col-">
      <span (click)="toggleActiveFilter()" class="material-icons filter-button">
        filter_list
        </span>
    </div>
  </div>
  <div class="modal fade" id="templatelistModal" tabindex="-1" role="dialog" >
    <app-projecttemplatelist (projecttoadd)="addProjectToList($event)" ></app-projecttemplatelist>
  </div>
<!--Delete modal-->
<div class="modal fade" id="deletemodal" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'orgprojectlist.deleteprojectmodal' | trans }}</h5>
        <button #closeconfirm type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="alert alert-danger">
              {{ 'orgprojectlist.deleteprojectmodalwarning' | trans }}
           </div>
            <p class="text-centermb-2 text-muted">{{ 'orgprojectlist.deleteprojectmodalconfirm' | trans }}</p>
          </div>
        </div>
       <div class="row">
        <div class="col">
          <button data-dismiss="modal" class="btn-save float-left"><h6 class="btn-save-text">{{ 'orgprojectlist.cancel' | trans }}</h6></button>
        </div>
        <div class="col">
          <button (click)="deleteProject()" class="btn-close float-right"><h6 class="btn-save-text">{{ 'orgprojectlist.confirmdelete' | trans }}</h6></button>
      </div>
       </div>
      </div>

    </div>
  </div>
</div>


<div class="container m-0 p-0">
  <div id="orgProjectEditModal" class="modal fade" role="dialog">
    <app-orgprojectedit [project]="clickedproject" ></app-orgprojectedit>
  </div>
</div>
<div class="container p-0 m-0">
  <div id="orgProjectAddModal" class="modal fade" role="dialog">
    <app-orgprojectadd (projecttoadd)="addProjectToList($event)"></app-orgprojectadd>
  </div>
</div>

<!-- Modal ASSIGN PEOPLE -->
<div class="modal fade" id="assignPeople" tabindex="-1" role="dialog" aria-labelledby="assignPeopleTitle" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgprojectlist.assigntoprojectmodal' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div  (click)="shiftFwd()" class="toggle-planner-right">
          <span class="material-icons cursor-pointer navigate-right">
              navigate_next
              </span>
      </div>  
      <div (click)="shiftBwd()" class="toggle-planner-left">
        <span class="material-icons navigate-left cursor-pointer">
            navigate_before
            </span>
    </div>
        <div class="row" style="margin-bottom:5px;">
          <div class="col">
          </div>
          <div class="col">
            <h6 class="h6" style="text-align:center;">{{date0 | date: 'dd-MM-yyyy'}} to {{date1 | date: 'dd-MM-yyyy'}}</h6>
          </div>
          <div class="col">
        </div>
    </div>  
        <div *ngFor="let mem of assignablePersons" class="row" >
          <div class="card" style="  margin: 10px;
          padding: 10px;
          border: #f2f2f2 2px solid;
          border-top: #f2f2f2 2px solid !important;
          background-color: #ffffff;
          width: 100%;
          border-radius: 5px;">
            <div class="row" style="margin-bottom:10px;">
              <div class="col">
                <h6 class="card-person-text  cursor-default" id="name">{{ mem.membername }}</h6>
              </div>
              <div class="col">
                <h6 class="card-person-text text-align-center cursor-default" id="name">{{ mem.member_function }}</h6>
              </div>
              <div class="col text-align-center">
                <a *ngIf="!mem.assigned" class="cursor-pointer" matTooltip="{{ 'orgprojectlist.assigntoprojectmodal' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                <span (click)="mem.assigned = true" class="material-icons card-person-text-read text-align-center assign-icon">
                  add
                  </span></a>
                  <a *ngIf="mem.assigned" class="cursor-pointer" matTooltip="{{ 'orgprojectlist.assigntoprojectmodal' | trans }}t" matTooltipPosition="above" matTooltipShowDelay="500">
                    <span (click)="mem.assigned = false" class="material-icons card-person-text-read text-align-center assigned-icon">
                      done
                      </span></a>
              </div>
            </div>
          </div>
        </div>

        <div *ngFor="let pmem of projectMembers" class="row">
          <div class="card cursor-default" style="  margin: 10px;
          padding: 10px;
          border: #fafafa 1px solid;
          border-top: #fafafa 1px solid !important;
          background-color: #f2f2f2;
          width: 100%;
          border-radius: 5px;">
            <div class="row">
              <div class="col">
                <h6 class="card-person-text-read" id="name">{{pmem.fullname}}</h6>
              </div>
              <div class="col">
                <h6 class="card-person-text-read" id="name">{{pmem.projectrole}}</h6>
              </div>
              <div class="col text-align-center">
                <span class="material-icons card-person-text-read text-align-center">
                  do_disturb_alt
                  </span>
              </div>
            </div>
            <div class="row">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
          <div class="col">
            <button type="button" class="btn-close" data-dismiss="modal"><h6 class="btn-save-text">{{ 'orgprojectlist.assigntoprojectmodalclose' | trans }}</h6></button>
          </div>
          <div class="col">
            <button type="button" data-dismiss="modal" data-toggle="modal" data-target="#assignRole" class="btn-save float-right"><h6 class="btn-save-text">{{ 'orgprojectlist.assigntoprojectmodal' | trans }}</h6></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal ASSIGN ROLE -->
<div class="modal fade" id="assignRole" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgprojectlist.assignprojectrolemodal' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body" style="min-height: 100px; max-height: 500px; overflow-y: scroll;">
        <div class="row" style="margin-bottom: 10px;">
          <div *ngIf="assignProject.templateId" class="col">
            <h6 class="h6">{{ 'orgprojectlist.predefined' | trans }}</h6>
            <p class="mb-0">{{ 'orgprojectlist.predefinedhelp' | trans }}</p>
            <button class="btn" data-toggle="collapse" data-target="#templaterolecollapse" ><p class="btn-text">{{ 'orgprojectlist.predefinedselect' | trans }}</p></button>
          </div>
          <div class="col">
            <h6 class="h6">{{ 'orgprojectlist.define' | trans }}</h6>
            <p>{{ 'orgprojectlist.definedhelp' | trans }}</p>
            <button class="btn" data-toggle="collapse" data-target="#blankrolecollapse" ><p class="btn-text">{{ 'orgprojectlist.definedselect' | trans }}</p></button>
          </div>
        </div>

        <div *ngFor="let memb of assignablePersons" class="form-group">
          <div *ngIf="assignProject.templateId" class="collapse" id="templaterolecollapse">
            <label class="modal-title" *ngIf="memb.assigned == true" id="userid" for="formGroupExampleInput">{{memb.membername}}</label>
            <app-assigntemplateroles (roleNameToAssign)="memb.projectrole = $event" *ngIf="memb.assigned == true" [project]="assignProject" [personId]="memb.personId"></app-assigntemplateroles>
          </div>
          <div class="collapse" id="blankrolecollapse">
            <label class="modal-title" *ngIf="memb.assigned == true" id="userid" for="formGroupExampleInput">{{ 'orgprojectlist.userrolefor' | trans }}{{memb.membername}}</label>
            <input style="font-size: 13px; font-weight: 100;"  *ngIf="memb.assigned == true" type="text" class="form-control" id="formGroupExampleInput" placeholder="{{ 'orgprojectlist.typeuserrolefor' | trans }}" [(ngModel)]="memb.projectrole">
          </div>
        </div>
        
        <div class="row row-spacer">
          <div class="col">
            <button type="button" class="btn-close" data-dismiss="modal"><h6 class="btn-save-text">{{ 'orgprojectlist.close' | trans }}</h6></button>
          </div>
          <div class="col">
            <button (click)="assignToProject()" data-dismiss="modal" type="button" class="btn-save float-right"><h6 class="btn-save-text">{{ 'orgprojectlist.accept' | trans }}</h6></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="disableProject" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgprojectlist.disableorenableproject' | trans }}</h5>
        <button #closeDisablemodal type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p style="text-align: center;">{{ 'orgprojectlist.hereyoucandisableorenableyourprojects' | trans }}</p>
        <div class="row" style="padding-top:20px;" >
          <div class="col" *ngIf="setActiveStateProject.isactive == true">
            <button  (click)="disableProject()" type="button" data-dismiss="modal" class="btn-close"><h6 class="btn-save-text">{{ 'orgprojectlist.disableproject' | trans }}</h6></button>
          </div>
          <div class="col" *ngIf="setActiveStateProject.isactive == false">
            <button  (click)="activateProject()" type="button"  data-dismiss="modal" class="btn-save"><h6 class="btn-save-text">{{ 'orgprojectlist.enableproject' | trans }}</h6></button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal manage tags-->
<div class="modal fade" id="taghandlerModal" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{ 'orgprojectlist.managetags' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ 'orgprojectlist.managetagshelp' | trans }}</p>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="{{ 'orgprojectlist.managetagsplace' | trans }}" aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append h-35">
            <button class="btn btn-outline-secondary" type="button"><p class="btn-text">{{ 'orgprojectlist.create' | trans }}</p></button>
          </div>
        </div>
        
        <button class="btn pt-1 pl-2 pr-2 pb-1">
          <p class="btn-text mb-0">{{ 'orgprojectlist.tag1' | trans }}          
            <span 
            class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
            close
          </span>
        </p>
        </button>

      </div>
    </div>
  </div>
</div>


<!-- Modal assign tags-->
<div class="modal fade" id="assignTags" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{ 'orgprojectlist.assigntags' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ 'orgprojectlist.assigntagshelp' | trans }}</p>
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="{{ 'orgprojectlist.managetagsplace' | trans }}" aria-label="Recipient's username" aria-describedby="basic-addon2">
          <div class="input-group-append h-35">
            <button class="btn btn-outline-secondary" type="button"><p class="btn-text">{{ 'orgprojectlist.create' | trans }}</p></button>
          </div>
        </div>
        <button class="btn pt-1 pl-2 pr-2 pb-1">
          <p class="btn-text mb-0">{{ 'orgprojectlist.tag1' | trans }}           
            <span 
            class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
            add
          </span>
        </p>
        </button>

        <div class="row border mt-3 mb-3 mr-0 ml-0 pl-2 pr-2"></div>

        <button class="btn pt-1 pl-2 pr-2 pb-1">
          <p class="btn-text mb-0">{{ 'orgprojectlist.tag1' | trans }}          
            <span 
            class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
            close
          </span>
        </p>
        </button>

      </div>
    </div>
  </div>
</div>